import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './index';

export type State = {
  currentCustomer: GetCustomerProfileResponse;
};

const initialState: State = {
  currentCustomer: {} as any,
};

const customer = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCurrentCustomer(state, { payload }: PayloadAction<GetCustomerProfileResponse>) {
      state.currentCustomer = payload;
    },
  },
});

export const { setCurrentCustomer } = customer.actions;
export const selectedCurrentCustomer = (state: RootState) => state.customer.currentCustomer;

export default customer.reducer;
